import { render, staticRenderFns } from "./PriceDisclosure.vue?vue&type=template&id=4c29566c"
import script from "./PriceDisclosure.vue?vue&type=script&lang=js"
export * from "./PriceDisclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports